module.exports = __webpack_public_path__ + "4ac049925e7a210094d84c4ad74e289c.png";